import {Component, Input} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {SelectConfig} from '../../model/select-config';

@Component({
  selector: 'nc-checkbox-cell',
  templateUrl: './nc-checkbox-cell.component.html',
  styleUrls: ['./nc-checkbox-cell.component.scss']
})
export class NcCheckboxCellComponent {
  @Input() rowData: any;
  @Input() selectConfig: SelectConfig;

  constructor(private formBuilder: FormBuilder) {
  }

  select = (item: string, $event): void => {
    $event.stopPropagation();
    if (this.selectConfig.isSingleSelect) {
      this.selectConfig.formArray.clear();
    }

    const selectedItem = this.formBuilder.group({
      value: [item]
    });

    this.selectConfig.formArray.push(selectedItem);
  }

  deselect = (item: string, $event): void => {
    $event.stopPropagation();
    if (!this.selectConfig.isSingleSelect) {
      const index = this.selectConfig.formArray.getRawValue().findIndex(x => x.value === item);
      this.selectConfig.formArray.removeAt(index);
    }
  }

  isSelected = (item: string): boolean => {
    return this.selectConfig != null ? this.selectConfig.formArray.getRawValue().filter(x => x.value === item).length > 0 : false;
  }
}
